import _get from "lodash/get";
import { css } from 'styled-components';
import { lighten, darken, transparentize, rem } from 'polished';
import buttonTheme from './buttonTheme';

var buttonStyles = function buttonStyles(props) {
  return css(["border:1px solid transparent;border-radius:", ";cursor:pointer;display:", ";font-family:", ";font-size:", ";font-weight:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";text-align:center;text-transform:uppercase;touch-action:manipulation;transition:background-color 0.15s ease-in-out,color 0.15s ease-in-out;user-select:none;vertical-align:middle;white-space:nowrap;&,&:hover,&:focus,&:active{outline:0;text-decoration:none;}", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
    var theme = _ref.theme,
        sizeValue = _ref.sizeValue;
    return _get(theme, "button.roundedCorners", buttonTheme.button.roundedCorners) ? rem(_get(theme, "button.borderRadius[" + sizeValue + "]", buttonTheme.button.borderRadius[sizeValue])) : '0';
  }, props.blockValue ? 'block' : 'inline-block', function (_ref2) {
    var theme = _ref2.theme;
    return _get(theme, 'button.fontFamily', buttonTheme.button.fontFamily);
  }, function (_ref3) {
    var theme = _ref3.theme,
        sizeValue = _ref3.sizeValue;
    return rem(_get(theme, "button.fontSize[" + sizeValue + "]", buttonTheme.button.fontSize[sizeValue]));
  }, function (_ref4) {
    var theme = _ref4.theme;
    return _get(theme, 'button.fontWeight', buttonTheme.button.fontWeight);
  }, function (_ref5) {
    var theme = _ref5.theme,
        sizeValue = _ref5.sizeValue;
    return rem(_get(theme, "button.padding[" + sizeValue + "].v", buttonTheme.button.padding[sizeValue].v));
  }, function (_ref6) {
    var theme = _ref6.theme,
        sizeValue = _ref6.sizeValue;
    return rem(_get(theme, "button.padding[" + sizeValue + "].h", buttonTheme.button.padding[sizeValue].h));
  }, function (_ref7) {
    var theme = _ref7.theme,
        sizeValue = _ref7.sizeValue;
    return rem(_get(theme, "button.padding[" + sizeValue + "].h", buttonTheme.button.padding[sizeValue].h));
  }, function (_ref8) {
    var theme = _ref8.theme,
        sizeValue = _ref8.sizeValue;
    return rem(_get(theme, "button.padding[" + sizeValue + "].v", buttonTheme.button.padding[sizeValue].v));
  }, function (_ref9) {
    var btnType = _ref9.btnType;
    return btnType === 'default' && css(["background-color:", ";border-color:", ";color:", ";&:hover{background-color:", ";border-color:", ";color:", ";}&:focus,&:active{background-color:", ";border-color:", ";color:", ";}"], function (_ref10) {
      var theme = _ref10.theme,
          skin = _ref10.skin;
      return _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background);
    }, function (_ref11) {
      var theme = _ref11.theme,
          skin = _ref11.skin;
      return _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border);
    }, function (_ref12) {
      var theme = _ref12.theme,
          skin = _ref12.skin;
      return _get(theme, "button[" + skin + "].color", buttonTheme.button[skin].color);
    }, function (_ref13) {
      var theme = _ref13.theme,
          skin = _ref13.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    }, function (_ref14) {
      var theme = _ref14.theme,
          skin = _ref14.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    }, function (_ref15) {
      var theme = _ref15.theme,
          skin = _ref15.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].color", buttonTheme.button[skin].color));
    }, function (_ref16) {
      var theme = _ref16.theme,
          skin = _ref16.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    }, function (_ref17) {
      var theme = _ref17.theme,
          skin = _ref17.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    }, function (_ref18) {
      var theme = _ref18.theme,
          skin = _ref18.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].color", buttonTheme.button[skin].color));
    });
  }, function (_ref19) {
    var btnType = _ref19.btnType;
    return btnType === 'outlined' && css(["background-color:transparent;border-color:", ";color:", ";&:hover{border-color:", ";color:", ";}&:focus,&:active{border-color:", ";color:", ";}"], function (_ref20) {
      var theme = _ref20.theme,
          skin = _ref20.skin;
      return _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border);
    }, function (_ref21) {
      var theme = _ref21.theme,
          skin = _ref21.skin;
      return _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background);
    }, function (_ref22) {
      var theme = _ref22.theme,
          skin = _ref22.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    }, function (_ref23) {
      var theme = _ref23.theme,
          skin = _ref23.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    }, function (_ref24) {
      var theme = _ref24.theme,
          skin = _ref24.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    }, function (_ref25) {
      var theme = _ref25.theme,
          skin = _ref25.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    });
  }, function (_ref26) {
    var btnType = _ref26.btnType;
    return btnType === 'link' && css(["background-color:transparent;border:0;color:", ";font-weight:400;text-transform:inherit;&:hover{color:", ";}&:focus,&:active{color:", ";}"], function (_ref27) {
      var theme = _ref27.theme,
          skin = _ref27.skin;
      return _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background);
    }, function (_ref28) {
      var theme = _ref28.theme,
          skin = _ref28.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    }, function (_ref29) {
      var theme = _ref29.theme,
          skin = _ref29.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    });
  }, function (_ref30) {
    var btnType = _ref30.btnType;
    return btnType !== 'link' && css(["&:focus,&:active{box-shadow:0 0 2px 4px ", ";}"], function (_ref31) {
      var theme = _ref31.theme,
          skin = _ref31.skin;
      return transparentize(0.8, _get(theme, "button[" + skin + "].background", buttonTheme.button[skin].background));
    });
  }, function (_ref32) {
    var icon = _ref32.icon;
    return icon && css(["&:hover{fill:", ";}&:focus,&:active{fill:", ";}"], function (_ref33) {
      var theme = _ref33.theme,
          skin = _ref33.skin;
      return lighten(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    }, function (_ref34) {
      var theme = _ref34.theme,
          skin = _ref34.skin;
      return darken(0.05, _get(theme, "button[" + skin + "].border", buttonTheme.button[skin].border));
    });
  }, function (_ref35) {
    var blockValue = _ref35.blockValue;
    return blockValue && css(["width:100%;"]);
  }, function (_ref36) {
    var disabled = _ref36.disabled;
    return disabled && css(["cursor:not-allowed;opacity:0.65;pointer-events:none;"]);
  });
};

export default buttonStyles;